import React, { Fragment , useRef } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import useWindowSize from '../Hooks/useWindowSize';
import {
  query as applyQuery,
  setSearchQuery,

} from '../Actions/QuickSearch.action';
import ProductsViewListItemSlim from '../Components/ProductsViewListItemSlim';

const QuickSearchResult = ({ result, otherResult, selectedItem, searchUrl, query, popularSearches, popularLinks }) => {

  const dispatch = useDispatch();
  const ref = useRef(null)
  const[windowHeight] = useWindowSize();

  const initialResult = !query || !(query.length > 0);

  const search = (q) => {
    dispatch(setSearchQuery(q));
    dispatch(applyQuery(q));
  }

  const sameCategory = (item, index, array) =>
  (index > 0 && array[index - 1].category === array[index].category) ||
  item.showAll;

  let hasOtherResult = otherResult && otherResult.length > 0;
  let productsOnly = !initialResult && !hasOtherResult;
  let leftAreaColumnClasses = productsOnly ? "small-12 large-12" : "small-12 large-8";
  let showShadow =  ref.current && isOverflown(ref.current) ? " quick-search-result__products--depthshadow" : "";


  function isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }

  return( 
    <div className="row quick-search-result">
      <div className={"columns " + leftAreaColumnClasses + " quick-search-result__left"}>
        <h4>{initialResult ? translate('quicksearch.popular.products') : translate('quicksearch.products')}</h4>
        <ul ref={ref} className={"quick-search-result__products" + showShadow}>
        {result &&
          result.map((item, index, array) => (
            <Fragment key={`${item.name}-${index}`}>                           
                <ProductsViewListItemSlim product={item} showBuyButton={item.showBuyButton} showComparisonButton={true} showAddToOffer={true}/>   
            </Fragment>
          ))}
        </ul>
        {!initialResult &&
          <div className="quick-search-result__show-all">
            <a href={searchUrl} className="btn btn-primary">{translate('quicksearch.showall')}</a>
          </div>
        }
      </div>
      <div className="columns small-12 large-4 quick-search-result__right">
        {initialResult ? 
        <>
          {popularSearches && popularSearches.length > 0 &&
          <div>
            <h4>{translate('quicksearch.popular.searches')}</h4>
            <ul>
              {popularSearches.map((query) => 
              <li onClick={() => search(query.text)}>{query.text}</li>
              )}
            </ul>
          </div>
          }
          {popularLinks && popularLinks.length > 0 &&
          <div>
            <h4>{translate('quicksearch.popular.links')}</h4>
            <ul>
              {popularLinks.map((link) => 
              <li>
                <a href={link.link?.href}>{link.link?.text}</a>
              </li>          
              )}
            </ul>
          </div>
          }
        </>
       :
       <>
       {otherResult &&
          otherResult.map((item, index, array) => (
              <Fragment key={`${item.name}-${index}`}>
                {item.category === 'NoHit' || item.category === 'ShowAll' || sameCategory(item, index, array) ? null : (
                    <li className="quick-search-result__item">
                      <h4>{item.category}</h4>
                    </li>
                  )}
                  <li
                    className={`quick-search-result__item ${
                      selectedItem === index
                        ? 'quick-search-result__item--selected'
                        : ''
                    }`}
                  >                           
                    <a href={item.url}>{item.name}</a>
                  </li>
              </Fragment>
          ))
        } 
        </>
      }
      </div>
    </div>
  
  );}

export default QuickSearchResult;
